import { Injectable } from '@angular/core';
import { OrderStateService } from './order-state.service';
import { planTypeName, planDeviceName } from 'src/app/utils/string';
import { HD_CABLE_INFO_MAP } from '../models/iorder-state.model';
import { GoogleTagManagerService } from 'angular-google-tag-manager';

@Injectable({
  providedIn: 'root',
})
export class GtmEcommerceService {
  constructor(private orderState: OrderStateService, private gtmService: GoogleTagManagerService) {}

  private getBaseEcommerceData(): any {
    const planType = this.orderState.planType;
    const planTypeNameStr = planTypeName(planType);

    return {
      currency: 'USD',
      value: this.orderState.subTotalPriceWithDiscount(),
      items: [
        {
          item_id: this.orderState.subscriptionPlanCode(),
          item_name: 'Subscription Fee',
          ...(this.orderState?.promoVendor && { affiliation: this.orderState?.promoVendor }),
          item_category: `${planTypeNameStr} Plan`,
          item_variant: this.orderState.billingPeriod() === 'annual' ? 'Annual' : 'Monthly',
          index: 0,
          price: this.orderState.oneVehicleTrackingPrice(),
          google_business_vertical: 'custom',
          quantity: this.orderState.devicesCount(),
        },
        {
          item_id: `${
            planType === 'pro' ? 'dashcam' : 'tracker'
          }_device_${planType}_${this.orderState.billingPeriod()}`,
          item_name: 'Device Activation Fee',
          ...(this.orderState?.promoVendor && { affiliation: this.orderState?.promoVendor }),
          item_category: `${planTypeNameStr} Plan`,
          item_category2: planDeviceName(planType),
          item_variant: this.orderState.billingPeriod() === 'annual' ? 'Annual' : 'Monthly',
          index: 1,
          price: this.orderState.oneDevicePrice(),
          google_business_vertical: 'custom',
          quantity: this.orderState.devicesCount(),
        },
        ...this.orderState.cableCartItems
          .filter(({ productCode }) => !!productCode)
          .map(({ productCode, quantity }, i) => ({
            item_id: productCode,
            item_name: 'Heavy Duty Cable',
            item_category: HD_CABLE_INFO_MAP[productCode]?.name || '',
            index: 2 + i,
            price: 0,
            google_business_vertical: 'custom',
            quantity,
          })),
      ],
    };
  }

  public pushBeginCheckout(): void {
    this.gtmService.pushTag({ ecommerce: null });
    const gtmTag = {
      event: 'begin_checkout',
      ecommerce: this.getBaseEcommerceData(),
    };
    this.gtmService.pushTag(gtmTag);
  }

  public pushViewCart(): void {
    this.gtmService.pushTag({ ecommerce: null });
    const gtmTag = {
      event: 'view_cart',
      ecommerce: this.getBaseEcommerceData(),
    };
    this.gtmService.pushTag(gtmTag);
  }

  public pushPurchase(): void {
    this.gtmService.pushTag({ ecommerce: null });
    const gtmTag = {
      event: 'purchase',
      ecommerce: {
        ...this.getBaseEcommerceData(),
        ...(this.orderState.getPromoCode() && { coupon: this.orderState.getPromoCode() }),
        ...(this.orderState.discountAmount() > 0 && { discount: this.orderState.discountAmount() }),
        tax: this.orderState.taxesPrice(),
        shipping: 0.0,
      },
    };
    this.gtmService.pushTag(gtmTag);
  }
}
